import React from 'react';
import { Controller } from 'react-hook-form';
import { FormFeedback, Input } from 'reactstrap';
import { CLAIM_FORM_TYPES } from '../../../pages/ExpenseClaims/Employee/EmployeeExpenseClaim/constants';

export default function SelectElement({
  formMethods,
  name,
  type = 'select',
  options = [],
  formType,
  title,
}) {
  const {
    control,
    formState: { errors },
  } = formMethods;

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            type={type}
            name={name}
            className={`form-control external-filter-input ${errors?.[name] ? 'is-invalid' : ''}`}
            disabled={formType === CLAIM_FORM_TYPES.VIEW}
            title={title}
          >
            <option value="">-- Select One --</option>
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        )}
      />
      {errors?.[name] && <FormFeedback>{errors?.[name]?.message}</FormFeedback>}
    </>
  );
}
